import axios from 'axios';
import constants from './constants';
const client = axios.create({
  baseURL: constants.API_URL,
});

client.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
    }else if(error.response && error.response.status === 404){
    }
    return Promise.reject(error);
  }
);


client.interceptors.response.use(
  (response) => {
    // Handle the response data
    const currentUrl = window.location.href;
    const containsQuestionMark = currentUrl.includes('?');
    if(containsQuestionMark){
      // window.location.href = '/error_404';
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
     // localStorage.removeItem('USER_TOKEN')
    //  window.location.href = '/login'; 
    }else if(error.response && error.response.status === 404){
    //  window.location.href = '/error_404';
    }
    return Promise.reject(error);
  }
);
function getauthtoken(){
  let token = localStorage.getItem('USER_TOKEN');
  let Authtoken = '';
  if(token !==null && token !=='' && token !==undefined){
      Authtoken = token;
  }
  const config = {
    headers: { 'X-Authorization': `Bearer ${Authtoken}` }
  }; 
  return config;
}
function getauthtemptoken(){
  let token = localStorage.getItem('TEMP_USER_TOKEN');
  let Authtoken = '';
  if(token !==null && token !=='' && token !==undefined){
      Authtoken = token;
  }
  const config = {
    headers: { 'X-Authorization': `Bearer ${Authtoken}` }
  }; 
  return config;
}
export class ApiService {
  static async fetchData(url) {
    try {
      const response = await client.get(url, getauthtoken());
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async postData(url,data) {
    try {
      const response = await client.post(url, data, getauthtoken());
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async loginProccessPostData(url,data) {
    try {
      const response = await client.post(url, data, getauthtemptoken());
      return response.data;
    } catch (error) { 
      throw error;
    }
  }
  static async filterPostData(url,data) {
    try {
      const response = await client.post(url, data, getauthtoken());
      return response.data;
    } catch (error) { 
      throw error;
    }
  }
  static async numberFormat(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}



